
import BaseFirebaseRepository from '../../../components/repository/BaseFirebaseRepository';
import Membership from '../../../Model/merchant/Membership';

const instances = {}
const defaultInstanceKey = Math.random()
export default class MembershipRepository extends BaseFirebaseRepository {
    // Indicate that this repository use API instead of Firebase
    isUseAPI = true

    /**
     * @param {*} app
     * @return {MembershipRepository}
     */
    static getInstance(app) {
        if (app == null) {
            // By default, use instance created from main App
            app = MembershipRepository.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new MembershipRepository(app)
        }
        return instances[app]
    }
    getRef = () => {
        return null
    }
    getSingleRef = () => {
        // This repository uses API to load instead of Firebase, so this
        // function is not called
        return null
    }
    getBaseObject = () => {
        return new Membership()
    }
    getApiBaseUrl = (id) => {
        if (!id || id == 'all') {
            return `/merchant/api/membership`
        }
        else {
            return `/merchant/api/membership/%id%`.replace('%id%', id)
        }
    }
    getReloadEventKey = () => {
        return "membership_version.changed"
    }

    /**
     * Once we get the result from Firebase, will use this to preprocess the
     * data before pass assign the data to getBaseObject()
     */
     preprocessItem = (rawFirebaseData) => {
        rawFirebaseData.points = parseInt(rawFirebaseData.points || 0)
        return rawFirebaseData
    }

    /**
     * Parse raw API response before perform any logic
     * @returns {Object}
     */
    parseRawApiResponse = (rawResponse) => {
        if (rawResponse) {
            if (!Array.isArray(rawResponse)) {
                return [rawResponse]
            }
            else {
                return rawResponse
            }
        }
        return []
    }

    validate(membership) {
        return new Promise((resolve, reject) => {
            // New membership, need server side validation first
            if (!membership.id) {
                $.ajax({
                    url     : this.getApiBaseUrl() + "/validate",
                    type    : 'post',
                    data    : membership,
                    success : (res) => {
                        if (res == "OK") {
                            resolve(this)
                        }
                    },
                    timeout: 20000
                })
                .fail(xhr => {
                    let message = ""
                    let code = 0
                    try {
                        let json = JSON.parse(xhr.responseText)
                        if (json.message) {
                            message = json.message
                            code = json.code
                        }
                    }
                    catch {

                    }
                    reject({message, code})
                })
            }
            else if (membership.id > 0){
                // Edit data, local validation
                resolve(this)
            }
        })
    }

    topup = (membership, topupInfo) => {
        let url = this.getApiBaseUrl(membership.id) + "/topup"
        const apiCall = (resolve, reject, always) => {
            $.ajax({
                url     : url,
                type    : 'post',
                data    : topupInfo,
                success : (res) => {
                    if (res.id) {
                        res = this.preprocessItem(res)
                        res = Object.assign(this.getBaseObject(), res)
                        this.updateMainDataSet(res, true)
                        this.triggerSingleItemCallback(res.id)
                        this.triggerCallback()
                    }
                    resolve && resolve(res)
                },
                timeout: 20000
            })
            .fail(() => {
                reject()
            })
            .always(() => {
                always && always()
            })
        }

        // No callback passed, return Promise
        return new Promise((resolve, reject) => {
            apiCall(resolve, reject)
        })
    }

    save = (membership, success, always) => {
        let url = membership.id ?
            this.getApiBaseUrl(membership.id) + "/update" :
            this.getApiBaseUrl()

        let data = {
            merchant_id: membership.merchant_id,
            name: membership.name,
            phone_number: membership.phone_number,
            membership_number: membership.membership_number,
            redeem_rate: membership.redeem_rate,
            earn_rate: membership.earn_rate,
            mininum_redeem_point: membership.mininum_redeem_point,
            maximum_redeem_point: membership.maximum_redeem_point,

            // New membership benefit package to be attached to this membership
            new_membership_benefits: membership.new_membership_benefits,
        }

        const apiCall = (resolve, reject, always) => {
            $.ajax({
                url     : url,
                type    : 'post',
                data    : data,
                success : (res) => {
                    if (res.id) {
                        res = this.preprocessItem(res)
                        res = Object.assign(this.getBaseObject(), res)
                        this.updateMainDataSet(res, true)
                        this.triggerSingleItemCallback(res.id)
                        this.triggerCallback(null, true)
                    }
                    resolve && resolve(res)
                },
                timeout: 20000
            })
            .fail(() => {
                reject && reject()
            })
            .always(() => {
                always && always()
            })
        }

        if (!success) {
            // No callback passed, return Promise
            return new Promise((resolve, reject) => {
                apiCall(resolve, reject)
            })
        }
        else {
            apiCall(success, null, always)
        }
    }
}
